import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "w-full opacity-30 overflow-hidden",
      style: {
        marginTop: `calc(-1 * var(--header-height))`,
      }
    }, null, 4),
    _renderSlot(_ctx.$slots, "default", { isMobile: _ctx.isMobile })
  ]))
}